import { flow, JSON, pipe } from "fp";

import * as Data from "~/Data";
import { Request } from "~/Request";

export namespace Post {
  type Options = {
    readonly company: Data.Reference.Reference;
    readonly driver: Data.Reference.Reference;
    readonly text: string;
  };

  export const request = (options: Options): Request.Fn =>
    pipe(
      {
        endpoint: `/companies/${options.company.id}/drivers/${options.driver.id}/messages`,
        headers: { "Content-Type": "application/json" },
        body: JSON.Stringify.Always.short({
          text: options.text,
        }),
      },

      (config) =>
        flow(
          Request.fromConfig({ method: "POST", ...config }),
          Request.Expect.status(201)
        )
    );
}
